/**
 * @author WYX
 * @date 2019/12/26
 * @Description: 封面图指令模块
 */
angular.module('editPageFacepicModule', []).directive('editPageFacepic', [
    'trsHttpService',
    'globleParamsSet',
    function(trsHttpService, globleParamsSet) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageFacepic/editPageFacepic.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        // 这里是默认的封面图大小
                        // topAttachFilePicSize: '235,100',
                        topAttachFilePicSize: '16,9',
                    };
                    $scope.data = {
                        scaleImgSize: globleParamsSet.scaleImgSize(),
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {

                }

                /**
                 * [deleteUploaderImg description]删除上传后的图片
                 * @return {[type]}           [description]
                 */
                $scope.deleteUploaderImg = function(index) {
                    $scope.list.COVERLIST = [];
                };
                // 裁剪完图片后压缩
                $scope.scaleImg = function(src) {
                    $scope.list.COVERLIST = [];
                    $scope.list.COVERLIST.push({
                        APPFILE: src.imgName,
                        APPDESC: src.imgName,
                        PERPICURL: src.imgSrc,
                    });
                    // var params = {
                    //     FILENAME: src.imgName,
                    //     FOLDEREXT: 'W0',
                    //     SCALEHEIGHT: $scope.data.scaleImgSize.scaleHeight,
                    //     SCALEWIDTH: $scope.data.scaleImgSize.scaleWidth,
                    //     methodname: 'scaleImage',
                    //     serviceid: 'mlf_image',
                    // };
                    // trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'get').then(function(data) {
                    //     $scope.list.COVERLIST = [];
                    //     $scope.list.COVERLIST.push({
                    //         IMAGENAME: data.FN,
                    //         IMAGEURL: '/wcm/file/read_image.jsp?FileName=' + data.FN,
                    //     });
                    // });
                };
            },
        };
    },
]);
